<article class="cr-comment-card" [class.completed]="isCompleted" [class.active]="active" [class.reply-open]="replyOpen" [class.menu-open]="menuOpen" [attr.data-comment-id]="comment.notificationId">
  <div class="cr-card-topline">
    <button *ngIf="isPinned; else plainIcon" type="button" class="cr-card-comment-icon cr-card-comment-icon-button" title="Show annotation" [attr.aria-label]="'Show annotation ' + (number ?? '')" (click)="showAnnotation.emit()">
      <svg viewBox="0 0 24 24" focusable="false"><path d="M5.5 5.5h13a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-5.2L9.5 20v-3.5h-4A1.5 1.5 0 0 1 4 15V7a1.5 1.5 0 0 1 1.5-1.5Z"></path></svg>
    </button>
    <ng-template #plainIcon><span class="cr-card-comment-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false"><path d="M5.5 5.5h13a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-5.2L9.5 20v-3.5h-4A1.5 1.5 0 0 1 4 15V7a1.5 1.5 0 0 1 1.5-1.5Z"></path></svg>
    </span></ng-template>
    <div class="cr-card-top-actions">
      <span class="cr-card-date">{{ comment.createdDate | date: 'dd-MM-yyyy HH:mm' }}</span>
      <div class="cr-card-menu-wrap">
        <button type="button" class="cr-card-dots-btn" aria-label="Comment options" (click)="toggleMenu($event)">•••</button>
        <div class="cr-card-menu" *ngIf="menuOpen">
          <button type="button" (click)="onToggleDone()">{{ isCompleted ? 'Mark as not done' : 'Mark as done' }}</button>
          <button type="button" *ngIf="isAuthor" (click)="startEdit()">Edit</button>
          <button type="button" *ngIf="canAnnotate" (click)="onAnnotate()">{{ isPinned ? 'Move annotation' : 'Annotate' }}</button>
          <button type="button" class="danger" *ngIf="isAuthor" (click)="onDelete()">Delete</button>
        </div>
      </div>
    </div>
  </div>
  <div class="cr-card-author">{{ comment.userInfo?.name || comment.userInfo?.username }}</div>
  <ng-container *ngIf="!editing; else editTpl">
    <div class="cr-card-text" [class.completed-copy]="isCompleted">{{ comment.notificationText }}</div>
  </ng-container>
  <ng-template #editTpl>
    <textarea class="cr-card-edit-input" [(ngModel)]="editText"></textarea>
    <div class="cr-card-edit-actions">
      <button type="button" class="cr-btn cr-btn-primary cr-card-small-btn" (click)="submitEdit()">Save</button>
      <button type="button" class="cr-card-link-btn" (click)="cancelEdit()">Cancel</button>
    </div>
  </ng-template>
  <div class="cr-card-replies" [class.has-replies]="replies.length">
    <div class="cr-card-saved-reply" *ngFor="let reply of replies">
      <span class="cr-card-reply-author">{{ reply.userInfo?.name || reply.userInfo?.username }}</span>
      <input class="cr-card-reply-input saved" #replyInput [value]="reply.replyText" [readOnly]="!canEditReply(reply)" placeholder="Reply" (blur)="commitReplyEdit(reply, replyInput.value)" (keydown.enter)="replyInput.blur()" />
    </div>
  </div>
  <div class="cr-card-footer">
    <div class="cr-card-footer-left">
      <button type="button" class="cr-card-done-btn" [class.completed]="isCompleted" [attr.aria-pressed]="isCompleted" [title]="isCompleted ? 'Mark as not done' : 'Mark as done'" (click)="toggleDone.emit()">
        <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m5 10.2 3 3L15 6.5"></path></svg>
      </button>
      <span class="cr-card-reply-meta">{{ replyMeta }}</span>
    </div>
    <button type="button" class="cr-card-reply-link" (click)="replyOpen = !replyOpen">Add Reply</button>
  </div>
  <div class="cr-card-reply-composer" *ngIf="replyOpen">
    <textarea class="cr-card-reply-draft" [(ngModel)]="replyDraft" placeholder="Add a comment..." (keydown)="onReplyKeydown($event)"></textarea>
    <div class="cr-card-reply-actions">
      <button type="button" class="cr-btn cr-btn-primary cr-card-small-btn" (click)="submitReply()">Add Reply</button>
      <button type="button" class="cr-card-link-btn" (click)="replyOpen = false; replyDraft = ''">Cancel</button>
    </div>
  </div>
</article>
